import { Box, Button, LinearProgress, Modal } from "@mui/material";
import React, { useEffect } from "react";
import "./FileUploadModal.css";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import IoClose from "../../../../../assets/images/IoClose.svg";
import {
  fileUploadModalText,
} from "../../../../../constants/constant";
import FileIconUpload from "../../../../../assets/images/FileIconUpload.svg";
import TickCircleSVG from "../../../../../assets/images/TickCircleSVG";

const FileUploadModal = ({
  openModal = false,
  selectedFile,
  siMappingSelectedFile,
  setopenModal,
  progress = 0,
  setProgress,
  upladedSuccess,
  setUploadedSuccess,
  rawErrorMessage,
  dataErrorMessage,
  isActive,
}) => {

  useEffect(() => {
    if (upladedSuccess === "success") {
      const timer = setTimeout(() => {
        setopenModal(false);
      }, 1000); 
  
      return () => clearTimeout(timer); 
    }
  }, [upladedSuccess]);

  useEffect(() => {
    setUploadedSuccess("pending");
    let timer;
    if (openModal) {
      timer = setInterval(() => {
        setProgress((prevProgress) =>
          prevProgress === 100
            ? 100
            : prevProgress >= 80
            ? 80
            : (prevProgress += 10)
        );
      }, 800);
    }
    return () => {
      clearInterval(timer);
      setProgress(10);
    };
  }, [openModal]);



  return (
    <>
      <Modal
        open={openModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="fileUploadModal" onClick={(e) => e.stopPropagation()}>
          <Button
            className="closeModalBtn sizeLarge"
            onClick={(e) => {
              e.preventDefault();
              setopenModal(false);
              // dispatch(resetState());
            }}
          >
            <img width="24px" height="24px" src={IoClose} alt="close" />
          </Button>
          <div className="file_header">
            <div className="attach">Attachments</div>
            <div className="header_right d-flex align-items-baseline gap-3"></div>
          </div>
          <div className="w-100 modal-content-body d-flex flex-column align-items-center justify-content-center p-3">

              <div className="row w-100">
                <div className="col-md-12 file_progress_upload p-2 mb-2">
                  <span className="fileTitleUpload py-2 d-flex">
                    Voice of Customer ( MVOC ) data file{" "}
                  </span>
                  <div className="uploadContainer p-3 bg-white">
                    <div className="d-flex align-items-center gap-3 w-100">
                      <img src={FileIconUpload} alt="file" />
                      <div className="d-flex flex-column w-[100%]">
                        <div className="d-flex align-items-center justify-between">
                          <span className="fileName">{selectedFile?.name}</span>
                          {/* <div
                            className="delete_icon_circular"
                            onClick={() => setSelectedFile(null)}
                          >
                            <img
                              src={delete_icon}
                              alt="delete"
                              style={{ width: "20px", height: "15px" }}
                            />
                          </div> */}
                        </div>

                        <span className="uploadFileSize">
                          {(selectedFile?.size / 1024).toFixed(2)} kb
                        </span>
                      </div>
                    </div>
                    {upladedSuccess === "pending" && (
                      <div className="w-100 my-2 flex items-center gap-[12px]">
                        <LinearProgress
                          variant="determinate"
                          value={progress}
                          className="progressBg"
                          sx={{
                            color: "#6366F1",
                            backgroundColor: "#6366F1",
                          }}
                        />
                        <span className="uploadProgress">{progress}%</span>
                      </div>
                    )}
                    {upladedSuccess === "success" && (
                      <div className="w-100 mt-2 d-flex align-items-center justify-content-start gap-2">
                        <TickCircleSVG />
                        <span className="fileUploadSuccess">
                          {fileUploadModalText.uploadSuccessfull}
                        </span>
                      </div>
                    )}
                    {upladedSuccess === "fail" && (
                      <div className="w-100 mt-2 d-flex align-items-center justify-content-start gap-2">
                        {rawErrorMessage ? (
                          <span className="fileUploadError">
                            <CancelRoundedIcon color="red" /> {rawErrorMessage}
                          </span>
                        ) : (
                          " "
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {isActive && (
                  <div className="col-md-12 file_progress_upload p-2 mt-2">
                    <span className="fileTitleUpload py-2 d-flex">
                      Strategic Imperative ( SI ) mapping{" "}
                    </span>
                    <div className="uploadContainer p-3 bg-white">
                      <div className="d-flex align-items-center gap-3 w-100">
                        <img src={FileIconUpload} alt="file" />
                        <div className="d-flex flex-column w-[100%]">
                          <div className="d-flex align-items-center justify-between">
                            <span className="fileName">
                              {siMappingSelectedFile?.name}
                            </span>
                            {/* <div
                              className="delete_icon_circular"
                              onClick={() => setSiMappingSelectedFile(null)}
                            >
                              <img
                                src={delete_icon}
                                alt="delete"
                                style={{ width: "20px", height: "15px" }}
                              />
                            </div> */}
                          </div>
                          <span className="uploadFileSize">
                            {(siMappingSelectedFile?.size / 1024).toFixed(2)} kb
                          </span>
                        </div>
                      </div>
                      {upladedSuccess === "pending" && (
                        <div className="w-100 my-2 flex items-center gap-[12px]">
                          <LinearProgress
                            variant="determinate"
                            value={progress}
                            sx={{
                              color: "#6366F1",
                              backgroundColor: "#6366F1",
                            }}
                          />
                          <span className="uploadProgress">
                            {progress}% 
                          </span>
                        </div>
                      )}
                      {upladedSuccess === "success" && (
                        <div className="w-100 mt-2 d-flex align-items-center justify-content-start gap-2">
                          <TickCircleSVG />
                          <span className="fileUploadSuccess">
                            {fileUploadModalText.uploadSuccessfull}
                          </span>
                        </div>
                      )}
                      {upladedSuccess === "fail" && (
                        <div className="w-100 mt-2 d-flex align-items-center justify-content-start gap-2">
                          {dataErrorMessage ? (
                            <span className="fileUploadError">
                              <CancelRoundedIcon color="red" />{" "}
                              {dataErrorMessage}
                            </span>
                          ) : (
                            " "
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>


            {/* {validationStart && (
                <>
                  {" "}
                  <div className="validate_header w-100">
                    <div className="validate_filename">
                      <FileIconUploadSVG conWidth="20" iconHeight="26" viewBox="0 6 30 42" />

                      <span className="saved-filename">{selectedFile?.name}</span>
                    </div>
                    <div className="validate_filename">
                      <FileIconUploadSVG conWidth="20" iconHeight="26" viewBox="0 6 30 42" />
                      <div className="d-flex flex-column">
                        <span className="saved-filename">{siMappingSelectedFile?.name}</span>
                      </div>
                    </div>
                  </div>
                  <div className="validate_body m-2">
                    <div className="success_message">
                      <div className="subTitle-text-upload">{fileUploadModalText.dataValidationInsightsGeneration}</div>

                      {[
                        validateFiles.maliciousCheck,
                        validateFiles.validateId,
                        validateFiles.validateDataFile,
                        validateFiles.validateRawFile,
                        validateFiles.validateDataRowValidationCheck,
                        validateFiles.validateDataSingleCheck,
                        validateFiles.validateDataMultiCheck,
                        validateFiles.validateDataRankingCheck,
                        validateFiles.validateDataNumericListCheck,
                        validateFiles.validateDataOpenTextListCheck,
                        validateFiles.validateDataGridCheck,
                        validateFiles.validateDataMatchCheck,
                      ].map((validationType) => (
                        <>
                          {(validationType.status === "success" || validationType.status === "pending") && (
                            <div className="d-flex gap-2 pb-2">
                              <div className="d-flex align-items-center">
                                {validationType.status === "pending" ? (
                                  <ImSpinner8 color="#4f46e5" fontSize="20px" className="rotating-spinner" />
                                ) : validationType.status === "success" ? (
                                  <IoCheckmarkCircle fontSize="20" color="#4F46E5" />
                                ) : (
                                  <IoCloseCircle fontSize="20" color="#EF0707" />
                                )}
                              </div>
                              {validationType.status === "pending" ? (
                                <span className="validationTextProcess">{validationType.message}</span>
                              ) : validationType.status === "success" ? (
                                <span className="validationText">{validationType.successMessage}</span>
                              ) : (
                                <span className="validationText">{validationType.errorMessage}</span>
                              )}
                            </div>
                          )}
                        </>
                      ))}
                    </div>
                    {validationStart &&
                      validateFiles.maliciousCheck.status === "success" &&
                      validateFiles.validateId.status === "success" &&
                      validateFiles.validateRawFile.status === "success" &&
                      validateFiles.validateDataFile.status === "success" &&
                      validateFiles.validateDataRowValidationCheck.status === "success" &&
                      validateFiles.validateDataSingleCheck.status === "success" &&
                      validateFiles.validateDataMultiCheck.status === "success" &&
                      validateFiles.validateDataRankingCheck.status === "success" &&
                      validateFiles.validateDataNumericListCheck.status === "success" &&
                      validateFiles.validateDataOpenTextListCheck.status === "success" &&
                      validateFiles.validateDataGridCheck.status === "success" &&
                      validateFiles.validateDataMatchCheck.status === "success" && (
                        <div className="validation-success-message mt-2">
                          {mergedFileStatus && !mergedFileStatusIsError && (
                            <span className="d-flex justify-content-start align-items-center gap-2">
                              <IoCheckmarkCircle fontSize="20" color="#2EBC7C" />
                              {fileUploadModalText.mergedFileSuccessFull}
                            </span>
                          )}
                          {!mergedFileStatus && !mergedFileStatusIsError && (
                            <span className="d-flex justify-content-start align-items-center gap-2">
                              <ImSpinner8 color="#4f46e5" fontSize="20px" className="rotating-spinner" />
                              {fileUploadModalText.mergedFileInProgress}
                            </span>
                          )}
                          {mergedFileStatusIsError && (
                            <span className="d-flex justify-content-start align-items-center gap-2">
                              <IoCloseCircle fontSize="20" color="#EF0707" />
                              {fileUploadModalText.failedToMergeFile}
                            </span>
                          )}
                        </div>
                      )}

                    {validationStart &&
                  validateFiles.maliciousCheck.status === "success" &&
                  validateFiles.validateId.status === "success" &&
                  validateFiles.validateRawFile.status === "success" &&
                  validateFiles.validateDataFile.status === "success" &&
                  validateFiles.validateDataMatchCheck.status === "success" &&
                  mergedFileStatus && (
                    <div className="validation-success-message mt-2">
                      {parsedFileStatus && (
                        <span className="d-flex justify-content-start align-items-center gap-2">
                          <IoCheckmarkCircle fontSize="20" color="#2EBC7C" />
                          Merged file has been parsed successfully
                        </span>
                      )}
                      {!parsedFileStatus && (
                        <span className="d-flex justify-content-start align-items-center gap-2">
                          <ImSpinner8 color="#4f46e5" fontSize="20px" className="rotating-spinner" />
                          Merged file parsing is in progress, Please wait!!
                        </span>
                      )}
                    </div>
                  )}

                    <span className="disclaimer">Note: {fileUploadModalText.disclaimerNote}</span>

                    {validationError === "true" && (
                      <div className={validationError === "true" && "error_message"}>
                        {[
                          validateFiles.maliciousCheck,
                          validateFiles.validateId,
                          validateFiles.validateDataFile,
                          validateFiles.validateRawFile,
                          validateFiles.validateDataRowValidationCheck,
                          validateFiles.validateDataSingleCheck,
                          validateFiles.validateDataMultiCheck,
                          validateFiles.validateDataRankingCheck,
                          validateFiles.validateDataNumericListCheck,
                          validateFiles.validateDataOpenTextListCheck,
                          validateFiles.validateDataGridCheck,
                          validateFiles.validateDataMatchCheck,
                        ].map((validationType) => (
                          <>
                            {validationType.status === "error" && (
                              <div className="d-flex gap-2 pb-2">
                                <div className="d-flex align-items-center">
                                  {validationType.status === "pending" ? (
                                    <ImSpinner8 color="#4f46e5" fontSize="20px" className="rotating-spinner" />
                                  ) : validationType.status === "success" ? (
                                    <IoCheckmarkCircle fontSize="20" color="#4F46E5" />
                                  ) : (
                                    <IoCloseCircle fontSize="20" color="#EF0707" />
                                  )}
                                </div>
                                <span className="validationText">{validationType.errorMessage} </span>
                              </div>
                            )}
                          </>
                        ))}
                      </div>
                    )}
                  </div>
                </>
              )} */}
          </div>
          {/* >>>>>>>>>>>>> spinning validation>>>>>>>>>>>>>>>>>>>>>>>>> */}
          {/* <div className="w-100 d-flex justify-content-between align-items-baseline pb-3 px-3 gap-2">
              {validationStart &&
                hasError &&
                validateFiles.maliciousCheck.status === "error" ||
                (validateFiles?.validateId?.status === "error" ||
                  validateFiles?.validateDataFile?.status === "error" ||
                  validateFiles?.validateRawFile?.status === "error" ||
                  validateFiles?.validateDataRowValidationCheck?.status === "error" ||
                  validateFiles?.validateDataSingleCheck?.status === "error" ||
                  validateFiles?.validateDataMultiCheck?.status === "error" ||
                  validateFiles?.validateDataRankingCheck?.status === "error" ||
                  validateFiles?.validateDataNumericListCheck?.status === "error" ||
                  validateFiles?.validateDataOpenTextListCheck?.status === "error" ||
                  validateFiles?.validateDataGridCheck?.status === "error" ||
                  validateFiles?.validateDataMatchCheck?.status === "error") && <span className="error-text">{fileUploadModalText.uploadCorrectFiles}</span>}
              <div className="footer-btns">
                {!validationStart ? (
                  <>
                    {upladedSuccess === "fail" ? (
                      <ButtonComponent
                        onClick={(e) => {
                          e.preventDefault();
                          setopenModal(false);
                          dispatch(resetState());
                        }}
                        variant="outlined"
                        btnType="error"
                        text="Close"
                        className={"btnDanger"}
                      />
                    ) : (
                      <>
                        {!mergedFileStatus &&
                      (!validateFiles.maliciousCheck.error ||
                        !validateFiles.validateId.error ||
                        !validateFiles.validateRawFile.error ||
                        !validateFiles.validateDataFile.error ||
                        !validateFiles.validateDataMatchCheck.error) && (
                        <>
                          <ButtonComponent
                            onClick={(e) => {
                              e.preventDefault();
                              setopenModal(false);
                              dispatch(resetState());
                            }}
                            variant="outlined"
                            btnType="error"
                            text="Close"
                            className={"btnDanger"}
                          />
                        </>
                      )}
                      </>
                    )}
                    <ButtonComponent
                  onClick={() => validateFilesSequential()}
                  variant="contained"
                  btnType="primary"
                  text="Validate & Merge"
                  className="btnPrimary"
                  disabled={upladedSuccess !== "success"}
                />
                  </>
                ) : (
                  <>
                    {validationStart &&
                    hasError &&
                    (validateFiles.maliciousCheck.status === "error" ||
                      validateFiles?.validateId?.status === "error" ||
                      validateFiles?.validateDataFile?.status === "error" ||
                      validateFiles?.validateRawFile?.status === "error" ||
                      validateFiles?.validateDataRowValidationCheck?.status === "error" ||
                      validateFiles?.validateDataSingleCheck?.status === "error" ||
                      validateFiles?.validateDataMultiCheck?.status === "error" ||
                      validateFiles?.validateDataRankingCheck?.status === "error" ||
                      validateFiles?.validateDataNumericListCheck?.status === "error" ||
                      validateFiles?.validateDataOpenTextListCheck?.status === "error" ||
                      validateFiles?.validateDataGridCheck?.status === "error" ||
                      validateFiles?.validateDataMatchCheck?.status === "error") ? (
                      <ButtonComponent
                        onClick={(e) => {
                          e.preventDefault();
                          setopenModal(false);
                          dispatch(resetState());
                        }}
                        variant="outlined"
                        btnType="error"
                        text="Close"
                        className="btnDanger"
                      />
                    ) : (
                      <>
                        {!mergedFileStatus &&
                      (validateFiles.maliciousCheck.error ||
                        validateFiles.validateId.error ||
                        validateFiles.validateRawFile.error ||
                        validateFiles.validateDataFile.error ||
                        validateFiles.validateDataMatchCheck.error) && (
                        <ButtonComponent
                          onClick={(e) => {
                            e.preventDefault();
                            setopenModal(false);
                            dispatch(resetState());
                          }}
                          variant="outlined"
                          btnType="error"
                          text="Close"
                          className="btnDanger"
                        />
                      )}
                      </>
                    )}
                    <ButtonComponent
                  onClick={() => {
                    dispatch(resetState());
                    setopenModal(false);
                  }}
                  variant="contained"
                  btnType="primary"
                  text="Submit"
                  className="btnPrimary"
                  disabled={
                    !mergedFileStatus &&
                    (!validateFiles.maliciousCheck.error ||
                      !validateFiles.validateId.error ||
                      !validateFiles.validateRawFile.error ||
                      !validateFiles.validateDataFile.error ||
                      !validateFiles.validateDataMatchCheck.error)
                  }
                />
                  </>
                )}
              </div>
            </div> */}
          {/* >>>>>>>>>>>>> spinning validation>>>>>>>>>>>>>>>>>>>>>>>>> */}
        </Box>
      </Modal>
    </>
  );
};

export default FileUploadModal;
